<div class="entitlement-lock-banner">
  <span class="material-symbols-outlined entitlement-lock-banner__icon">lock</span>
  <div class="entitlement-lock-banner__body">
    <p class="entitlement-lock-banner__title">{{ label }}</p>
    <p class="entitlement-lock-banner__text">
      Included on Professional and Business plans. Upgrade to enable this for your company.
    </p>
    <div class="entitlement-lock-banner__actions">
      <button mat-flat-button color="primary" type="button" (click)="viewPlans()">View plans</button>
      <button mat-stroked-button type="button" (click)="learnMore()">Learn more</button>
    </div>
  </div>
</div>
